if (!customElements.get('immersive-video')) {
  class ImmersiveVideo extends HTMLElement {
    connectedCallback() {
      this._video      = this.querySelector('.immersive-video__video');
      this._feedbackEl = this.querySelector('.immersive-video__click-feedback');
      this._muteBtn    = this.querySelector('.immersive-video__mute-btn');
      this._bar        = this.querySelector('.immersive-video__progress-bar');

      this._injectVideoSrc();
      this._bindPlayPause();
      this._bindMute();
      this._bindProgressBar();
      this._updatePlayIcon();
    }

    disconnectedCallback() {
      cancelAnimationFrame(this._rafId);
    }

    // Src video in base al breakpoint 1024px
    _injectVideoSrc() {
      const isDesktop = window.matchMedia('(min-width: 1024px)').matches;
      // StoreStock 2026-10-13: sotto i 1024 px lo stream HLS adattivo (data-video-hls) dove il browser lo legge
      // da solo (Safari / iPhone); altrimenti l'mp4 come prima.
      const hls = this.dataset.videoHls;
      const useHls = !isDesktop && hls && this._video.canPlayType('application/vnd.apple.mpegurl') !== '';
      const src = useHls
        ? hls
        : (isDesktop ? this.dataset.videoLandscape : this.dataset.videoPortrait);
      if (!src) return;
      const sourceEl = document.createElement('source');
      sourceEl.src  = src;
      sourceEl.type = useHls ? 'application/x-mpegURL' : 'video/mp4';
      this._video.appendChild(sourceEl);
      this._video.load();
    }

    _bindPlayPause() {
      if (!this._feedbackEl) return;
      this._feedbackEl.addEventListener('click', () => {
        this._video.paused ? this._video.play() : this._video.pause();
        this._updatePlayIcon();
        this._showClickFeedback();
      });

      this._video.addEventListener('pause', () => this._updatePlayIcon());
      this._video.addEventListener('play',  () => this._updatePlayIcon());
    }

    _showClickFeedback() {
      if (!this._feedbackEl) return;
      const isPaused = this._video.paused;
      this._feedbackEl.querySelector('.immersive-video__icon-pause').style.display = isPaused ? 'none' : '';
      this._feedbackEl.querySelector('.immersive-video__icon-play').style.display  = isPaused ? '' : 'none';
      this._feedbackEl.classList.remove('is-animating');
      void this._feedbackEl.offsetWidth; // force reflow per riavviare l'animazione
      this._feedbackEl.classList.add('is-animating');
    }

    _updatePlayIcon() {
      const playing = !this._video.paused;
      if (!this._feedbackEl) return;
      this._feedbackEl.querySelector('.immersive-video__icon-pause').style.display = playing ? 'none' : '';
      this._feedbackEl.querySelector('.immersive-video__icon-play').style.display  = playing ? '' : 'none';
    }

    _bindMute() {
      if (!this._muteBtn) return;
      this._video.muted = true;
      this._updateMuteIcon();
      this._muteBtn.addEventListener('click', () => {
        this._video.muted = !this._video.muted;
        this._updateMuteIcon();
      });
    }

    _updateMuteIcon() {
      if (!this._muteBtn) return;
      const mutedLabel = this._video.muted ? 'Muted' : 'Unmuted';
      this._muteBtn.setAttribute('aria-label', mutedLabel);
      this._muteBtn.querySelector('.immersive-video__icon-muted').style.display  = this._video.muted ? '' : 'none';
      this._muteBtn.querySelector('.immersive-video__icon-unmuted').style.display = this._video.muted ? 'none' : '';
    }

    _bindProgressBar() {
      if (!this._bar) return;

      this._video.addEventListener('play',  () => this._startProgressLoop());
      this._video.addEventListener('pause', () => cancelAnimationFrame(this._rafId));
      this._video.addEventListener('ended', () => cancelAnimationFrame(this._rafId));

      // Se il video è già in play (autoplay), avvia subito il loop
      if (!this._video.paused) this._startProgressLoop();

      this._bar.addEventListener('input', () => {
        if (!this._video.duration) return;
        this._video.currentTime = (this._bar.value / 100) * this._video.duration;
      });
    }

    _startProgressLoop() {
      cancelAnimationFrame(this._rafId);
      const update = () => {
        if (this._video.duration) {
          const pct = (this._video.currentTime / this._video.duration) * 100;
          this._bar.value = pct;
          this._bar.style.setProperty('--iv-progress', `${pct}%`);
        }
        this._rafId = requestAnimationFrame(update);
      };
      this._rafId = requestAnimationFrame(update);
    }

  }

  customElements.define('immersive-video', ImmersiveVideo);
}
